var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"gc-card-text__list-text"},[_c('text-body-extra-small',{staticClass:"gc-card-text__list-text__item-number",attrs:{"line-height":'multi'}},[_vm._v(_vm._s(_vm.itemNumber)+" ")]),_c('text-body-extra-small',{attrs:{"line-height":'multi'}},[_c('p',{domProps:{"innerHTML":_vm._s(_vm.text)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }